import { text } from '@modules/forgot-password/text';
import { useAuthActions } from '@convex-dev/auth/react';

import { useForgotPasswordStore } from '@shared/store/useForgotPasswordStore';

export function useForgotPasswordRequest(
  onSuccess: (message: string) => void,
  onError: (message: string) => void
) {
  const { signIn } = useAuthActions();
  const form = useForgotPasswordStore((s) => s.form);
  const setIsSubmitting = useForgotPasswordStore((s) => s.setIsSubmitting);
  const setStep = useForgotPasswordStore((s) => s.setStep);

  return () => {
    if (!form.email) return;

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append('email', form.email);
    formData.append('flow', 'reset');

    signIn('password', formData)
      .then(() => {
        onSuccess(text.requestSuccess);
        setIsSubmitting(false);
        setStep('verify');
      })
      .catch((error: Error) => {
        onError(error.message || text.requestError);
        setIsSubmitting(false);
      });
  };
}
